module.exports = __webpack_public_path__ + "img/faq52.c4e169cc.png";